module.exports = __webpack_public_path__ + "img/u56.c9edb02d.png";